import React, { useState, createContext } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import CategoriesContainer from './components/CategoriesContainer';
import SnoozesContainer from './components/SnoozesContainer';

import Select from 'react-select';
import HeaderComponent from '../../../components/header/HeaderComponent';
import SnoozeDialogue from './SnoozeDialogue';
import { addJobForSnooze, updateSnoozeState } from "../utils/commonSnoozeUtils";

const stateManager = require('../../../utils/state/stateManager.js');
const menuSnoozeViewUtil = require('./menuSnoozeUtil.js');
const constants = require('../../../utils/domain/constants.js');
const viewUtil = require('../../../utils/view/viewUtil');
const navigationPageAction = require("../../../utils/state/actions/views/navigationPage/navigationPageAction");
const storefrontUtility = require("../../../utils/domain/storefrontUtility");
const translator = require("../../../utils/translator/translator");

const styles = {
    container: (base) => ({
        ...base,
        width: '50%',
        marginLeft: '10%'
    }),
    control: (base, state) => ({
        ...base,
        height: '100%',
        borderColor: state.isFocused ? "var(--colors-primary)" : base.borderColor
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    menu: (base) => ({
        ...base,
        marginTop: '1px'
    }),
    menuList: (base) => ({
        ...base,
        paddingTop: 'none',
        paddingBottom: 'none'
    }),
    option: (base, state) => ({
        ...base,
        lineHeight: '2',
        backgroundColor: state.isSelected ? "var(--colors-primary)" : base.backgroundColor
    })
}

export const MenuContext = createContext(null);

function MenuSnooze({ title, menus, snoozes })
{
    const storefronts = storefrontUtility.getAllStorefronts();

    menus = menus.filter(menu => storefronts.filter(storefront => storefront.menuId === menu.id).length);
    const [selectedMenu, setSelectedMenu] = useState(menus.length ? menus[0] : {});
    
    const [snooze, setSnooze] = useState(null);
    const [showSnoozeDialog, setShowSnoozeDialog] = useState(false);

    const snoozesWithPrimaryId = {};
    snoozes.forEach(snooze =>
    {
        if (snooze.type === constants.SnoozeTypes.menuItem)
        {
            snooze.isExisting = true;
            snooze.isUpdated = false
            snoozesWithPrimaryId[snooze.primaryId] = JSON.parse(JSON.stringify(snooze));
        }
    })
    const [snoozesMap, setSnoozesMap] = useState(snoozesWithPrimaryId);

    const menuOptions = menus.map(menu => ({ label: menu.name, value: menu.id }));

    const handleCancel = function ()
    {
        stateManager.getStore().dispatch(navigationPageAction.createAction(null));
    }

    const handlePublish = function ()
    {
        const updatedSnoozes = [];
        const allSnoozes = [];
        Object.keys(snoozesMap).forEach(snoozePrimaryId => {
            const snooze = snoozesMap[snoozePrimaryId];
            if (snooze.isUpdated)
            {
                updatedSnoozes.push(snooze);
            }
            allSnoozes.push(snooze);
        });

        if (updatedSnoozes.length)
        {
            const handlePromptSubmit = () => 
            {
                addJobForSnooze(updatedSnoozes, constants.SnoozeTypes.menuItem);
                updateSnoozeState(allSnoozes, constants.SnoozeTypes.menuItem);
                handleCancel();
            };

            const handlePromptCancel = () => 
            {
                viewUtil.clearAlert();
            };

            const promptTitle = translator.getLabel("publish_snoozed_menu");
            const promptMessage = translator.getLabel("publish_snoozed_menu_message");
            viewUtil.showPrompt(promptTitle, promptMessage, "", handlePromptSubmit, handlePromptCancel);
        }
        else 
        {
            handleCancel();
        }
    }

    const getSelectedMenuSnoozes = function () 
    {
        const filteredSnoozes = {};
        Object.keys(snoozesMap).forEach(primaryId =>
        {
            if (snoozesMap[primaryId].menus.includes(selectedMenu.id)) 
            {
                filteredSnoozes[primaryId] = snoozesMap[primaryId];
            }
        });
        return filteredSnoozes;
    }

    const handleSnooze = function (item, isCategoryItem)
    {
        const itemType = isCategoryItem ? constants.SnoozeItemTypes.categoryItem : constants.SnoozeItemTypes.modifierItem;
        const newSnooze = menuSnoozeViewUtil.createBlankSnooze(selectedMenu);
        newSnooze.primaryId = item.id;
        newSnooze.secondaryId = itemType;
        newSnooze.isSnoozed = true;
        setSnooze(newSnooze);
        setShowSnoozeDialog(true);
    }

    const handleItemActivation = function (item, isCategoryItem)
    {
        const itemType = isCategoryItem ? constants.SnoozeItemTypes.categoryItem : constants.SnoozeItemTypes.modifierItem;
        const existingSnooze = menuSnoozeViewUtil.getSnoozedItem(selectedMenu.id, snoozesMap, item.id, itemType);
        if (existingSnooze) 
        {
            existingSnooze.isUpdated = true;
            existingSnooze.isSnoozed = false;
            setSnoozesMap(prevState => ({ ...prevState, [existingSnooze.primaryId]: existingSnooze }));
        }
    }

    const handleEditSnooze = function (snooze)
    {
        setSnooze(snooze);
        setShowSnoozeDialog(true);
    }

    const handleDeleteSnooze = function (snooze)
    {
        if (snooze.isExisting) 
        {
            snooze.isUpdated = true;
            snooze.isSnoozed = false;
            setSnoozesMap(prevState => ({ ...prevState, [snooze.primaryId]: snooze }));
        }
        else 
        {
            setSnoozesMap(prevState =>
            {
                const updatedSnoozes = {...prevState};
                delete updatedSnoozes[snooze.primaryId];
                return updatedSnoozes;
            })
        }
    }

    const handleDialogSubmit = function (snoozePreferences)
    {
        const snoozes = getSelectedMenuSnoozes();
        const snoozedItem = menuSnoozeViewUtil.getSnoozedItem(selectedMenu.id, snoozes, snooze.primaryId, snooze.secondaryId);
        if (snoozedItem) 
        {
            snooze.isUpdated = true;
        }
        snooze.isSnoozed = true;
        snooze.expiryCaption = snoozePreferences.selectedExpiryCaption.value;
        snooze.expiry = snoozePreferences.selectedExpiry;
        snooze.dispatchTypes = snoozePreferences.selectedDispatchOptions.map(selectedDispatchOpt => selectedDispatchOpt.value);
        snooze.venueCodes = snoozePreferences.selectedVenueCodes.map(selectedVenueOpt => selectedVenueOpt.value);

        setSnoozesMap(prevState => ({ ...prevState, [snooze.primaryId]: snooze }));
        setShowSnoozeDialog(false);
        setSnooze(null);
    }

    const handleDialogCancel = function ()
    {
        setSnooze(null);
        setShowSnoozeDialog(false);
    }

    const handleMenuSelect = function (selectedMenuOption)
    {
        const menu = menus.find(menu => menu.id === selectedMenuOption.value);
        setSelectedMenu(menu);
    }

    return (
        <MenuContext.Provider value={{ menus: menus, selectedMenu, selectBoxStyles: styles, handleSnooze, handleItemActivation, snoozesMap }} >
            <div>
                <HeaderComponent title={title}>
                    <div className="d-flex justify-content-between">
                        <Select
                            value={menuOptions.find(menuOpt => menuOpt.value === selectedMenu.id)}
                            isSearchable={false}
                            placeholder={translator.getLabel("select_a_menu")}
                            options={menuOptions}
                            styles={styles}
                            onChange={handleMenuSelect}
                        />
                        <div className="d-flex gap-3">
                            <Button className="btn-cancel" onClick={handleCancel}>{translator.getLabel("cancel")}</Button>
                            <Button className="btn-ok" onClick={handlePublish}>{translator.getLabel("publish")}</Button>
                        </div>
                    </div>
                </HeaderComponent>
                <div className="d-flex gap-4" style={{ margin: "1.5rem 1.5rem" }}>
                    <div style={{ flex: "1 1 60%", border: "1px solid var(--colors-secondary)", borderRadius: "var(--button-roundness)" }}>
                        <CategoriesContainer />
                    </div>
                    <div style={{ flex: "1 1 30%" }}>
                        <SnoozesContainer
                            snoozes={snoozesMap}
                            selectedMenu={selectedMenu}
                            onEditSnooze={handleEditSnooze}
                            onDeleteSnooze={handleDeleteSnooze}
                        />
                    </div>
                </div>
                {snooze
                    ? <SnoozeDialogue
                        showModal={showSnoozeDialog}
                        snooze={snooze}
                        onSnooze={handleDialogSubmit}
                        onCancel={handleDialogCancel}
                    />
                    : <></>
                }

            </div>
        </MenuContext.Provider>
    )
}

const mapStateToProps = (state) => ({
    menus: state.menus,
    snoozes: state.snoozes
})

export default connect(mapStateToProps)(MenuSnooze);
